<template>
  <div class="page-loader"><div></div></div>
</template>

<script>
export default {
  name: "page-loader"
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/vars";

.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  div {
    height: 6px;
    background: $mainRed;
    transform-origin: 0 50%;
    animation: 4.5s ease-in-out infinite load;
  }
}

@keyframes load {
  0% {
    transform: scaleX(0);
  }
  50% {
    transform: scaleX(1);
    transform-origin: 0 50%;
  }
  51% {
    transform: scaleX(1);
    transform-origin: 100% 50%;
  }
  100% {
    transform: scaleX(0);
    transform-origin: 100% 50%;
  }
}
</style>
